export default function PHP_ignore_user_abort() {
  return (
    <div>
      <h1>PHP_ignore_user_abort</h1>
    </div>
  );
}
